module.exports = __webpack_public_path__ + "img/australia-diabetes-mellitus-female.512f3cad.png";